import React, { useRef, useState, useEffect } from "react";
import DraggableList from "react-draggable-list";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import Switch from "@mui/material/Switch";
import TextView from "../../../../../../TextView";
import { colors } from "../../../../../../../utils";
import { sanitizeUserHtml } from "../../../../../../../utils/sanitizeHtml";
import { Tooltip } from "@mui/material";

function ButtonsList({ allButtons, handleChangeButtonsList }) {
  const initialData = allButtons.map((button) => ({
    ...button,
    tooltipVisible: false,
  }));

  const [list, setList] = useState(initialData);

  useEffect(() => {
    handleChangeButtonsList(list);
  }, [list, handleChangeButtonsList]);

  const handleToggleActive = (id) => {
    setList((prevList) => {
      const activeItemsCount = prevList.filter((item) => item.isActive).length;
      return prevList.map((item) => {
        if (item.id === id) {
          // If toggling this item off and it's the only active one, prevent deactivation
          if (item.isActive && activeItemsCount === 1) {
            setTimeout(() => {
              setList((currentList) =>
                currentList.map((currentItem) =>
                  currentItem.id === id
                    ? { ...currentItem, tooltipVisible: false }
                    : currentItem
                )
              );
            }, 2000); // Hide the tooltip after 3 seconds

            return { ...item, tooltipVisible: true };
          }
          return { ...item, isActive: !item.isActive, tooltipVisible: false };
        }
        return item;
      });
    });
  };

  const DraggableButtons = ({ item, dragHandleProps }) => {
    const { onMouseDown, onTouchStart } = dragHandleProps;
    const containsHTML = /<\/?[a-z][\s\S]*>/i.test(item.title);
    return (
      <div
        style={{
          display: "flex",
          borderBottom: "0.5px solid grey",
          margin: "10px",
          padding: "10px",
          marginTop: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <DragIndicatorIcon
            className="disable-select dragHandle"
            style={{
              fontWeight: "600",
              fontSize: "20px",
              cursor: "grab",
              color: "#BBBBBB",
              marginLeft: "10px",
            }}
            onTouchStart={(e) => {
              e.preventDefault();
              console.log("touchStart");
              e.target.style.backgroundColor = "blue";
              document.body.style.overflow = "hidden";
              onTouchStart(e);
            }}
            onMouseDown={(e) => {
              console.log("mouseDown");
              document.body.style.overflow = "hidden";
              onMouseDown(e);
            }}
            onTouchEnd={(e) => {
              e.target.style.backgroundColor = "black";
              document.body.style.overflow = "visible";
            }}
            onMouseUp={() => {
              document.body.style.overflow = "visible";
            }}
          />
          <Tooltip
            title="At least 1 Button must be enabled"
            open={item.tooltipVisible}
            disableHoverListener
            disableFocusListener
            disableTouchListener
          >
            <Switch
              checked={item.isActive}
              onChange={() => handleToggleActive(item.id)}
              inputProps={{ "aria-label": "controlled" }}
              size="small"
              sx={{
                marginLeft: "5px",
                "& .MuiSwitch-switchBase.Mui-checked": {
                  color: "#81459B", // Custom color for the checked switch
                },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                  backgroundColor: "#81459B", // Custom color for the track
                },
              }}
            />
          </Tooltip>
        </div>
        {containsHTML ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "-15px",
              marginLeft: "15px",
            }}
            dangerouslySetInnerHTML={{
              __html: sanitizeUserHtml(item.title),
            }}
          ></div>
        ) : (
          <TextView
            style={{
              fontSize: "16px",
              color: colors.primary,
              fontWeight: "500",
              marginLeft: "15px",
            }}
          >
            {item.title}
          </TextView>
        )}
      </div>
    );
  };

  const containerRef = useRef();

  const _onListChange = (newList) => {
    setList(newList);
    handleChangeButtonsList(newList);
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <DraggableList
        itemKey="id"
        template={DraggableButtons}
        list={list}
        onMoveEnd={(newList) => _onListChange(newList)}
        container={() => containerRef.current}
      />
    </div>
  );
}

export default ButtonsList;
